import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ErrorStateActions, UserInfoActions, UserPermissionActions } from 'store/actionCreators'
import { useCookies } from 'react-cookie'
import { v4 as uuidv4 } from 'uuid'
import BridgeReceiver from 'components/containers/common/BridgeReceiver'
import AppStoreRedirectModal from 'components/presenters/modal/AppStoreRedirectModal'
import VersionChecker from 'components/containers/common/VersionChecker'
import NativeVersionChecker from 'components/containers/common/NativeVersionChecker'
import GoogleAnalytics from 'components/containers/common/GoogleAnalytics'
import DeviceChecker from 'components/containers/common/DeviceChecker'
// import UserPermissionChecker from 'components/containers/common/UserPermissionChecker'
// import AnnouncementModal from 'components/containers/common/AnnouncementModal'
import TooManyReqModal from 'components/containers/common/TooManyReqModal'
import UrlChangeNativeHandler from 'components/containers/common/UrlChangeNativeHandler'

import server from 'server/serverController2'
import { sendWebViewMsg } from 'utils/bridge'
export default function WrapperComponent(props) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })
  const errInfo = useSelector((state) => state.errorStateInfo)
  const history = useHistory()
  const [cookies, setCookie, removeCookie] = useCookies()

  const [showAppStoreModal, setShowAppStoreModal] = useState(false)

  const [load, setLoad] = useState(false)
  useEffect(() => {
    server.getRequestData('auth', (result) => {
      try {
        if (result && result.data) {
          UserInfoActions.updateRole({ role: result.data.userInfo.role })
          server.getRequestData(`users/${result.data.userInfo.user_no}`, (res) => {
            UserInfoActions.updateUserState({
              name: res.data.user.nickname,
              email: res.data.user.email,
              id: res.data.user.no,
              isLogin: true,
              achievement_goal: res.data.user.achievement_goal,
              profile_img: res.data.user.profile_img,
              exp_point: res.data.user.exp_point,
            })
            setLoad(true)
            setCookie('is_onboarding_completed', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
            sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
          })
        } else {
          UserInfoActions.initUserState({})
          UserPermissionActions.initUserPermission({})
          setLoad(true)
        }
      } catch (err) {
        UserInfoActions.initUserState({})
        UserPermissionActions.initUserPermission({})
        console.log(err)
      }
    })
  }, [])

  //Backbtn ForwardBtn Handler
  const [locationKeys, setLocationKeys] = useState([])
  useEffect(() => {
    let uuidVal = cookies['uuid']
    if (uuidVal) {
      setCookie('uuid', uuidVal, { path: '/', maxAge: 60 * 60 * 24 * 31 * 12 })
    } else {
      setCookie('uuid', uuidv4(), { path: '/', maxAge: 60 * 60 * 24 * 31 * 12 })
    }

    return history.listen((location) => {
      if (history.action === 'PUSH') {
        setLocationKeys([location.key])
      }

      if (history.action === 'POP') {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys)
          // Handle back event
          ErrorStateActions.setFetchErrState({ fetchErrTriggerd: false })
        } else {
          setLocationKeys((keys) => [location.key, ...keys])
          // Handle forward event

          ErrorStateActions.setFetchErrState({ fetchErrTriggerd: false })
        }
      }
    })
  }, [locationKeys])

  useEffect(() => {
    //const disableAppModal = cookies['disable_app_modal']; && disableAppModal !== 'true'
    if (userInfo['isApp'] === false && userInfo['isMobile'] === true) {
      setShowAppStoreModal(true)
    }
  }, [userInfo['isApp'], userInfo['isMobile']])

  if (!load) {
    return <div></div>
  } else {
    return (
      <>
        {showAppStoreModal && process.env.REACT_APP_ENV !== 'dev' ? (
          <AppStoreRedirectModal
            onClose={() => {
              setShowAppStoreModal(false)
              setCookie('disable_app_modal', 'true', { path: '/', maxAge: 60 * 60 * 24 * 1 })
            }}
          />
        ) : null}
        <GoogleAnalytics />
        <VersionChecker />
        <DeviceChecker />
        <NativeVersionChecker />
        <UrlChangeNativeHandler />
        <TooManyReqModal />
        {/* <UserPermissionChecker /> */}
        <BridgeReceiver />
        {/* <AnnouncementModal /> */}
        {props.children}
      </>
    )
  }
}
